import VueSweetalert2 from 'vue-sweetalert2'
import Vue from "vue"
import i18n from "../plugins/i18n"
import router from "@/plugins/Router"
import Base from "@/plugins/Base"
import { EventBus } from "@/main"

Vue.use(VueSweetalert2)

const half_timeout_min = 60
const extra_time_min   = 1
const showModalDifferentTime = 120
const notCheckRoutes   = ['/', '/login', '/oauth/authorize']

let sessionInterval    = null
let warnTimeout        = null
let logoutTimeout      = null
let idleWarnTimeout    = null
let idleLogoutTimeout  = null

const stopSessionTracking = () => {
    if (sessionInterval)   { clearInterval(sessionInterval);  sessionInterval   = null }
    if (warnTimeout)       { clearTimeout(warnTimeout);       warnTimeout       = null }
    if (logoutTimeout)     { clearTimeout(logoutTimeout);     logoutTimeout     = null }
    if (idleWarnTimeout)   { clearTimeout(idleWarnTimeout);   idleWarnTimeout   = null }
    if (idleLogoutTimeout) { clearTimeout(idleLogoutTimeout); idleLogoutTimeout = null }
}

const resetExpireCounter = () => {
    Base.LocalStorage.set(
        'expire_counter',
        Math.floor(Date.now() / 1000) + (half_timeout_min * 60)
    )
}

const scheduleTimeouts = () => {
    if (warnTimeout)       { clearTimeout(warnTimeout);       warnTimeout       = null }
    if (logoutTimeout)     { clearTimeout(logoutTimeout);     logoutTimeout     = null }
    if (idleWarnTimeout)   { clearTimeout(idleWarnTimeout);   idleWarnTimeout   = null }
    if (idleLogoutTimeout) { clearTimeout(idleLogoutTimeout); idleLogoutTimeout = null }

    const now            = Math.floor(Date.now() / 1000)
    const expire_in       = Base.LocalStorage.get('expire_in')
    const expire_counter  = Base.LocalStorage.get('expire_counter')

    if (expire_in) {
        const msUntilWarn   = (expire_in - showModalDifferentTime - now) * 1000
        const msUntilLogout = (expire_in + (extra_time_min * 60) - now) * 1000

        if (msUntilWarn > 0) {
            warnTimeout = setTimeout(() => {
                if (!notCheckRoutes.includes(router.history.current.path)) {
                    if (!Vue.swal.isVisible()) {
                        showAlert(showModalDifferentTime, 'full')
                    }
                }
            }, msUntilWarn)
        }

        if (msUntilLogout > 0) {
            logoutTimeout = setTimeout(() => {
                Vue.swal.close()
                stopSessionTracking()
                router.push('/logout')
            }, msUntilLogout)
        }
    }

    if (expire_counter) {
        const msUntilIdleWarn   = (expire_counter - now) * 1000
        const msUntilIdleLogout = (expire_counter + (extra_time_min * 60) - now) * 1000

        if (msUntilIdleWarn > 0) {
            idleWarnTimeout = setTimeout(() => {
                if (!notCheckRoutes.includes(router.history.current.path)) {
                    if (!Vue.swal.isVisible()) {
                        showAlert(30, 'half')
                    }
                }
            }, msUntilIdleWarn)
        }
        if (msUntilIdleLogout > 0) {
            idleLogoutTimeout = setTimeout(() => {
                Vue.swal.close()
                stopSessionTracking()
                router.push('/logout')
            }, msUntilIdleLogout)
        }
    }
}

const sessionTrackingRun = () => {
    if (notCheckRoutes.includes(router.history.current.path)) {
        stopSessionTracking()
        return
    }

    const token = Base.LocalStorage.get('access_token')
    if (!token) {
        stopSessionTracking()
        return
    }

    resetExpireCounter()

    scheduleTimeouts()

    if (!sessionInterval) {
        sessionInterval = setInterval(() => {
            const currentToken = Base.LocalStorage.get('access_token')
            const currentPath  = router.history.current.path
            if (!currentToken || notCheckRoutes.includes(currentPath)) {
                stopSessionTracking()
            }
        }, 5000)
    }
}

const showAlert = (seconds, mode = 'half') => {
    const previous_title = document.title
    document.title = i18n.t('session_timeout_warning')
    Vue.swal({
        title: i18n.t('session_timeout_warning'),
        text: i18n.t('session_timeout_warning_text'),
        showCancelButton: true,
        confirmButtonText: i18n.t('session_timeout_continue'),
        cancelButtonText: i18n.t('session_timeout_logout'),
        allowOutsideClick: false
    }).then(response => {
        if (mode === 'half') {
            if (response.isConfirmed) {
                document.title = previous_title
                resetExpireCounter()
                scheduleTimeouts()
            } else {
                router.push('/logout')
            }
        } else {
            if (response.isConfirmed) {
                getToken()
            } else {
                router.push('/logout')
            }
        }
    })
}

const getToken = () => {
    EventBus.$emit("captchaModalShow", true)
    Vue.swal.close()
}

export default {
    sessionTrackingRun,
    showAlert,
    stopSessionTracking
}
